import { Injectable } from '@angular/core';
import  {HttpClient} from '@angular/common/http';
import { AppConstants } from '../AppConstants';
import {ForgotPasswordDto} from '../model/ForgotPasswordDto';

@Injectable()
export class ForgotPasswordDtoService {

public httpOptions : any;

  constructor(private _http : HttpClient,private appConstant: AppConstants) {

  }


      //<><  ForgotPassword
     public  forgotPassword( forgotPasswordDto:ForgotPasswordDto ){


            return this._http.post(this.appConstant.baseAppUrl+"/api/forgotPasswordDto/forgotPassword", forgotPasswordDto);
     }
      //<><  SaveOtp
     public saveOtp(forgotPasswordDto:ForgotPasswordDto ) {


          return this._http.post(this.appConstant.baseAppUrl+"/api/forgotPasswordDto/saveOtp",forgotPasswordDto);
     }

      //<><  SaveVerifyOtp
     public saveVerifyOtp(forgotPasswordDto:ForgotPasswordDto ) {


          return this._http.post(this.appConstant.baseAppUrl+"/api/forgotPasswordDto/saveVerifyOtp",forgotPasswordDto);
     }

       findOne(id: number){

              return this._http.post(this.appConstant.baseAppUrl+"/api/forgotPasswordDto/findOne/"+id,"");
        }

        delete(id: number){

                    return this._http.post(this.appConstant.baseAppUrl+"/api/forgotPasswordDto/delete/"+id,"");
          }

}